var React = require('react');

function CheckmarkSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.5553 6.39759C19.0138 5.86881 18.1497 5.86728 17.6062 6.39414L9.12549 14.6163L6.38143 11.9662C5.83912 11.4424 4.9706 11.4515 4.4293 11.9763C3.86299 12.5254 3.85391 13.4428 4.42023 13.9919L8.15271 17.6105C8.69476 18.1361 9.55621 18.1361 10.0983 17.6105L19.5746 8.42315C20.1395 7.87545 20.1411 6.96955 19.5781 6.41986L19.5553 6.39759Z","fill":"#262F56"}));
}

CheckmarkSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckmarkSmall;

CheckmarkSmall.default = CheckmarkSmall;
